import React from "react";

export default function Save({ color = "#fff", ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="SaveIcon"
      x="0px"
      y="0px"
      viewBox="0 0 86 86"
      style={{ enableBackground: "new 0 0 86 86" }}
      xmlSpace="preserve"
      width="512px"
      height="512px"
      {...restProps}
    >
      <g>
        <path
          d="M76.609,0h-2.705H35.15H6.1C2.736,0,0,2.737,0,6.101V79.9C0,83.263,2.736,86,6.1,86h2.101h69.463   H79.9c3.363,0,6.1-2.736,6.1-6.1V9.39L76.609,0z M37.15,3.999h32.754v14.402c0,1.156-0.941,2.098-2.098,2.098H39.252   c-1.158,0-2.102-0.941-2.102-2.098V3.999z M73.664,82H12.201V38.849c0-1.156,0.941-2.098,2.1-2.098h57.264   c1.158,0,2.1,0.942,2.1,2.098V82z M82,79.9c0,1.158-0.941,2.1-2.1,2.1h-2.236V38.849c0-3.363-2.736-6.098-6.1-6.098H14.301   c-3.363,0-6.1,2.734-6.1,6.098V82H6.1C4.942,82,4,81.058,4,79.9V6.101c0-1.158,0.942-2.102,2.1-2.102H33.15v14.402   c0,3.361,2.738,6.098,6.102,6.098h28.555c3.363,0,6.098-2.736,6.098-6.098V3.999h1.049L82,11.046V79.9z"
          fill={color}
        />
        <rect x="63.842" y="6.101" width="4.109" height="12.176" fill={color} />
        <rect x="19.938" y="46.125" width="46.125" height={4} fill={color} />
        <rect x="19.938" y="55.521" width="46.125" height={4} fill={color} />
        <rect x="19.938" y="64.062" width="46.125" height={4} fill={color} />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
}
